import reducer from './reducers';

import exampleOperations from './operations';
import { types as exampleTypes } from './actions';

export {
  exampleOperations,
  exampleTypes,
};

export default reducer;
